module.exports = __webpack_public_path__ + "img/logo.5fa3fd6d.png";